import React from "react";

import BrownLivingIcon from "./../images/testimonials/brownliving.png";
import NesteryIcon from "./../images/testimonials/nestery.png";
import AndMeIcon from "./../images/testimonials/andme.png";
import ChemistIcon from "./../images/testimonials/chemist.png";
import GynovedaIcon from "./../images/testimonials/gynoveda.png";
import PetsutraIcon from "./../images/testimonials/petsutra.jpeg";

const testimonials = {
  col1: [
    {
      title: "Single platform for all our Shopify needs",
      description:
        "Earlier, It was very tedious and expensive to use different shopify apps for different marketing needs. With Growlytics, we were able to unify all our marketing efforts into a single platform and get better at managing KPIs.",
      brand: "Brown Living",
      image: BrownLivingIcon,
      name: "Chaitsi Ahuja",
    },
    {
      title: "Great upgrade from mailchimp",
      description:
        "Growlytics's shopify integration is just awesome. Earlier we had tons of limitation like using our local sms vendors and all. With growlytics, we own our marketing stack.",
      brand: "The Nestery",
      image: NesteryIcon,
      name: "Vaishnavi Nagrajan",
    },
  ],
  col2: [
    {
      title: "Amazing for automations & integrations",
      description:
        "Growlytics's automation suite is at next level compared to traditional automation platforms. It's focused more on e-commerce and integrates very well with industry's essecial platforms like judge.me, smile.io etc. Love'd the way omnichannel offering is provided in the same platform.",
      brand: "And Me",
      image: AndMeIcon,
      name: "Aman Sharma",
    },
    {
      title: "Awesome segmentation & personalization",
      description:
        "Being in medical business, we wanted to connect customers with our doctors for personalized guidelines for each medicine they buy, all automated. Growlytics has the best customer data platform to identify different group of customers based on their past behaviours, with integrated omni-channel automation suite we needed. ",
      // Growlytics gave us a unique opportunity to do data-driven marketing and retention on 5+ channels for our platform. Earlier, It was very tedious and expensive to use different apps for different marketing needs. With Growlytics, we were able to unify all our marketing efforts into a single platform and get better at managing KPIs.",
      brand: "Gynoveda",
      image: GynovedaIcon,
      name: "Elvis Quadros",
    },
  ],
  col3: [
    {
      title: "Simple and intituve platform",
      description:
        "Overall, Growlytics is easy to use, even as a beginner. The support team help center is also beneficial, and you can see most of common how-tos with good videos there, so no need to ask support team.",
      brand: "Petsutra",
      image: PetsutraIcon,
      name: "Devam Srivastava",
    },
    {
      title: "Very robust and open for integrations",
      description:
        "Growlytics's out of box integrations with shopify, review, cashback and loyalty platforms is simply amazing. In addition to that, we can integrate our own offline systems and use different vendors for email, sms and whatsapp. Very simple, efficient, open and robust platform.",
      brand: "Chemist At Play",
      image: ChemistIcon,
      name: "Rohan Chowdhury",
    },
  ],
};
export default function TestimonialsSection() {
  return (
    <section className="bg-white mt-0 md:mt-10 overflow-hidden mb-10">
      <div className="relative max-w-7xl mx-auto pt-10 pb-6 px-4 sm:px-6 lg:px-8 lg:py-10">
        <div className="relative">
          <div class="text-center ">
            <h1 className="font-bold text-gray-800 text-4xl md:text-4xl mb-14">
              Trusted By Growing Businesses
            </h1>
            {/* <div class="text-center mb-6 lg:mb-10">
              <span class="inline-block w-1 h-1 rounded-full bg-primary-600 ml-1"></span>
              <span class="inline-block w-3 h-1 rounded-full bg-primary-600 ml-1"></span>
              <span class="inline-block w-40 h-1 rounded-full bg-primary-600 ml-1"></span>
              <span class="inline-block w-3 h-1 rounded-full bg-primary-600 ml-1"></span>
              <span class="inline-block w-1 h-1 rounded-full bg-primary-600 ml-1"></span>
            </div> */}
          </div>
          <div class="-mx-3 md:flex items-start">
            {Object.keys(testimonials).map((col) => (
              <div class="px-3 md:w-1/3">
                {testimonials[col].map((testimonial) => (
                  <div class="w-full mx-auto rounded-lg bg-white border border-gray-200 p-5 text-gray-800 font-light mb-6">
                    <div class="w-full">
                      <h3 class="text-md font-bold text-primary-900">
                        {testimonial.title}
                      </h3>
                      <div class="text-sm leading-1 pt-1 text-gray-500">
                        {testimonial.description}
                      </div>
                    </div>
                    <div class=" mt-5 flex">
                      {/* Brand Info */}
                      <div class="items-center">
                        <div
                          class="w-12 h-12"
                          style={{
                            backgroundImage: `url("${testimonial.image}")`,
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                          }}
                        ></div>
                      </div>
                      <div class="w-full pl-3 pt-2">
                        <div class="text-xs text-gray-600">
                          {testimonial.name}
                        </div>
                        <div class="font-bold text-sm text-gray-900">
                          {testimonial.brand}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
